/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SimpleHorseRequest } from '../models/SimpleHorseRequest';
import { SimpleUserRequest } from '../models/SimpleUserRequest';
import { HttpFile } from '../http/http';

export class SimpleGroupHorseRequest {
    'horse': SimpleHorseRequest;
    'sponsor'?: SimpleUserRequest;
    'role'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "horse",
            "baseName": "horse",
            "type": "SimpleHorseRequest",
            "format": ""
        },
        {
            "name": "sponsor",
            "baseName": "sponsor",
            "type": "SimpleUserRequest",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return SimpleGroupHorseRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

